// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'
import isPresent from 'is-present'
import Moment from 'moment-timezone'

class FormBlock extends Model {
  defaults() {
    return {
      attrs:[],
      required_attrs: [],
      required_custom_field_ids: [],
      style: "",
      translations: {es:{},so:{},vi:{},it:{},pt:{}, ru: {},zh:{}, fr:{}},
      prefetch_new_element: null, // as spaghetti is used only to reload data
    }
  }

  mutations() {
    return {}
  }

  to_display(){
    if(this._to_display) return this._to_display;
    return this._to_display = this.attrs.some(attr=>this.attr_visible(attr)) || this.membership_id || this.custom_field_ids.length > 0
  }

  attr_visible(attr){
    if (attr === 'name' && (this.style === 'Product::FormBlock::PartAddress' || this.style === 'Product::FormBlock::PartParentAddress')) return false
    if (attr === 'other_type' && this.name !== 'Other') return false
    if (attr === 'relationship' && this.style === 'Product::FormBlock::PartDoctor') return  false
    return !(attr === 'doctor_type' || attr === 'school_type' || attr === 'parent_relation_name');
  }

  required_attributes(){
    return this.form_part.options_for(this.style)["required"] || {}
  }


  attr_required_by_builder(attr_name){
    return false;
    //for now we believe in DB
    // return this.required_attributes().includes(attr_name)
  }

  partial_name(){
    let arr = this.style.split("::")
    return arr[arr.length-1].toLowerCase()
  }

  visible_attributes(){
    if (this._visible_attributes) return this._visible_attributes
    return this._visible_attributes = this.attrs.filter(attr=> this.attr_visible(attr))
  }

  // has_custom_fields(){
  //   if(this.additional_block()) return true
  //   return this.form_part.has_custom_fields()
  // }
  //
  // additional_block(){
  //   return this.style == "Product::FormBlock::PartPersonAdditional"
  // }

}

export {
  FormBlock
}
